import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Secret/lock icon.
 *
 * A padlock shape: rounded rectangular body with a curved shackle on
 * top. Represents secrets, credentials, and locked resources.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Lock body: cyan accent fill at 10%
 * - Shackle: full currentColor (no fill)
 */
export const SecretIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Lock body with cyan accent fill */}
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2"
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Curved shackle on top (full currentColor, no fill) */}
    <path
      d="M8 11 L8 7 C8 4.79 9.79 3 12 3 C14.21 3 16 4.79 16 7 L16 11"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Keyhole dot in the lock body */}
    <circle cx="12" cy="16" r={1.5} fill="currentColor" />
  </RushaSvgIcon>
);

SecretIcon.displayName = "SecretIcon";

export default SecretIcon;
